/** Date and time in Swiss formats, e.g. 29.09.2026, 10:15. */
export function swissDateTimeFormat(locale: string): Intl.DateTimeFormat {
  return new Intl.DateTimeFormat(`${locale}-CH`, { dateStyle: 'medium', timeStyle: 'short' });
}
